import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import getId from '../services/get_id';
import updateTodo from '../services/update';

function UpdateTodo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    title: '',
    description: '',
    is_completed: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const updateHandler = async (e) => {
    e.preventDefault();
    const response = await updateTodo(id, data);
    if (response.status === 200) {
      alert('Todo updated successfully!');
      navigate('/todos');
    } else {
      alert('Error updating todo.');
      console.log(response);
    }
  };

  const fetchById = async (id) => {
    const response = await getId(id);
    const val = response.data.data;
    setData(val);
  };

  useEffect(() => {
    fetchById(id);
  }, [id]);

  return (
    <div className='flex items-center justify-center min-h-screen bg-gray-100'>
      <div className='w-full max-w-md p-6 bg-white rounded-lg shadow-md'>
        <h2 className='text-2xl font-bold text-center mb-6'>Update Todo</h2>
        <form onSubmit={updateHandler}>
          <div className='mb-4'>
            <label
              className='block text-gray-700 font-semibold mb-2'
              htmlFor='title'
            >
              Title
            </label>
            <input
              className='appearance-none border border-gray-300 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
              id='title'
              type='text'
              name='title'
              value={data.title}
              onChange={handleChange}
              placeholder='Enter the title'
              required
            />
          </div>
          <div className='mb-4'>
            <label
              className='block text-gray-700 font-semibold mb-2'
              htmlFor='description'
            >
              Description
            </label>
            <textarea
              className='appearance-none border border-gray-300 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
              id='description'
              name='description'
              value={data.description}
              onChange={handleChange}
              placeholder='Enter the description'
              required
            />
          </div>
          <div className='mb-4 flex items-center'>
            <input
              className='mr-2 leading-tight'
              id='is_completed'
              type='checkbox'
              name='is_completed'
              checked={data.is_completed}
              onChange={handleChange}
            />
            <label
              className='text-gray-700 font-semibold'
              htmlFor='is_completed'
            >
              Completed
            </label>
          </div>
          <button
            className='w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline'
            type='submit'
          >
            Update
          </button>
        </form>
      </div>
    </div>
  );
}

export default UpdateTodo;
